import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {fetchRoles} from '../../../redux/actions/rolesActions';
import {fetchAdmins,updateDefaultRows} from '../../../redux/actions/adminsActions';
import RowEdit from './RowEdit';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import {
  Divider as MuiDivider,
  Grid,
  CircularProgress,
  Button,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
} from '@mui/material';
import { spacing } from '@mui/system';
import InviteAdminModal from './InviteAdminModal';

const Divider = styled(MuiDivider)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => ({
    el,
    index,
  }));
  stabilizedThis.sort((a, b) => {
    const order = comparator(a.el, b.el);
    if (order !== 0) return order;
    return a.index - b.index;
  });
  return stabilizedThis.map((element) => element.el);
}

const headCells = [
  { id: 'email', alignment: 'left', label: 'Email' },
  { id: 'permissions', alignment: 'left', label: 'Permissions' },
  { id: 'invite', alignment: 'left', label: 'Invite' },
  { id: 'invitedate', alignment: 'left', label: 'Invited Date' },
  { id: 'actions', alignment: 'center', label: '' },
];

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            style={{
              fontSize: 'small',
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar>
      <ToolbarTitle>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h4" id="tableTitle">
            Admins
          </Typography>
        )}
      </ToolbarTitle>
      <Spacer />
    </Toolbar>
  );
};

function EnhancedTable({ rows, defaultRows, handleSubmit, actionsLoading }) {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('createdAt');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(defaultRows));
  const dispatch = useDispatch();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.idPrepTime);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    dispatch(updateDefaultRows(parseInt(event.target.value, 10)));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const [addOpen, setAddOpen] = useState(false);
  const handleAddOpen = () => {
    setAddOpen(true);
  };
  const handleAddClose = () => {
    setAddOpen(false);
  };



  return (
    <div>
      <Paper>
        <EnhancedTableToolbar numSelected={selected.length} />
        <Grid container spacing={6}>
          <Grid item >
            <span style={{ paddingLeft: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleAddOpen()}
                size="small"
              >
                Invite Admin
              </Button>
              <InviteAdminModal open={addOpen} handleClose={handleAddClose} handleSubmit={handleSubmit} />
            </span>
          </Grid>
        </Grid>
        <TableContainer sx={{ px: 3 }}>
          <Table
            aria-labelledby="tableTitle"
            size={'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.idAdminRole);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.idAdminRole}-${index}`}
                      selected={isItemSelected}
                    >
                      <RowEdit
                        row={row}
                        labelId={labelId}
                        handleSubmit={handleSubmit}
                        actionsLoading={actionsLoading}
                      />
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function Admins() {

  const navigate = useNavigate();
  const { userState } = useSelector(
    (state) => ({ userState: state.auth }),
    shallowEqual,
  );
  const { currentState } = useSelector(
    (state) => ({ currentState: state.admins }),
    shallowEqual,
  );
  const { entities, listLoading, actionsLoading } = currentState;

  const dispatch = useDispatch();

  const handleSubmit = async (values, handleClose) => {
    setInterval(() => {
      if (actionsLoading === false) {
        handleClose();
      }
    }, dispatch(fetchAdmins({})));
  };
  useEffect(() => {
    if (userState.isAuthenticated) {
       dispatch(fetchAdmins({}));
       dispatch(fetchRoles({}));
    } else {
      navigate('/');
    }
  }, [dispatch, userState.isAuthenticated, navigate]);


  return (
    <React.Fragment>
      <Helmet title="Admins" />
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            {'Welcome back'},{' '}
            {userState && userState.user && userState.user.displayName
              ? userState.user.displayName
              : 'Admin'}
          </Typography>
          <Typography variant="subtitle1" display="inline" sx={{ ml: 4 }}>
            {moment().format('dddd, DD MMMM, YYYY')}
          </Typography>
        </Grid>
      </Grid>

      <Divider my={6} sx={{ pb: 2 }} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          {listLoading ? (
            <Grid container direction="row" justifyContent="center">
              <CircularProgress sx={{ color: 'white' }} />
            </Grid>
          ) : (
            <EnhancedTable
              rows={entities === null ? [] : entities}
              defaultRows={currentState.defaultRows}
              handleSubmit={handleSubmit}
              actionsLoading={actionsLoading}
            />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Admins;
